export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  contentHtml: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    slug: 'kissxsis-plot-guide',
    title: '《亲吻姐姐》全集剧情深度解析：从第一集到最终话的完整故事线',
    excerpt: '带你从头到尾回顾亲吻姐姐的完整剧情，从圭太与两位姐姐的奇妙相遇，到三人关系逐渐升温的全过程，逐集拆解剧情中的每一个细节与伏笔。',
    contentHtml: `<h2>第一话：命运的相遇</h2><p>故事的开端，住之江圭太是一个普通的高中生，与没有血缘关系的双胞胎姐姐住之江亚香和住之江理香住在一起。亚香是学生会会长，成绩优秀、性格温柔体贴；理香则是活泼开朗的运动型少女。两位姐姐都对圭太怀有超越姐弟的特殊感情，而圭太则在两人之间摇摆不定。</p><p>第一话中，圭太面临着高中入学考试的挑战，两位姐姐用各自的方式为他加油打气。亚香用温柔细腻的方式照顾圭太的起居，而理香则用更加大胆直接的方式表达爱意。这一集奠定了整个故事的基调——青春、恋爱、喜剧的完美融合。</p><h2>第二话：三角关系的萌芽</h2><p>随着剧情推进，圭太逐渐意识到两位姐姐对自己的感情并非普通的姐弟之情。亚香在圭太生病时的悉心照料，理香在体育祭上的热情应援，每一个场景都让观众感受到那份青涩而真挚的情感。</p><p>这一集中，「间接接吻」的名场面首次出现——亚香在圭太喝过的饮料上轻轻抿了一口，这个细微的动作让无数观众心跳加速，成为了亲吻姐姐最具代表性的场景之一。</p><h2>第三话至第六话：感情的升温</h2><p>中间几集通过校园生活、家庭日常等多个场景，深入刻画了三人之间微妙的情感变化。暑假合宿、学园祭、圣诞派对等经典校园事件轮番上演，每一个场景都为三人关系的发展提供了新的契机。</p><p>特别值得一提的是第五话中的「雨中相拥」场景，亚香在雨中为圭太送伞的温柔举动，以及理香随后冲入雨中表达不满的率真表现，将三角关系的张力推向了高潮。</p><h2>最终话：未完成的答案</h2><p>亲吻姐姐的最终话并没有给出明确的恋爱结局，而是选择了一个开放式的结尾。圭太意识到两位姐姐在他生命中不可替代的重要性，三人约定无论未来如何变化，都要一直在一起。这个结局引发了粉丝们的热烈讨论，也正是这种「未完待续」的感觉，让亲吻姐姐在粉丝心中留下了永恒的印记。</p>`,
    category: 'plot-analysis',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20romance%20scene%20with%20soft%20warm%20lighting%2C%20high%20school%20setting%2C%20two%20girls%20and%20one%20boy%20in%20school%20uniforms%2C%20cherry%20blossom%20petals%20falling%2C%20pastel%20pink%20and%20cream%20background%2C%20gentle%20emotional%20atmosphere%2C%20anime%20art%20style%2C%20soft%20focus%2C%20dreamy%20lighting&width=800&height=450&seq=kissxsis-plot-guide&orientation=landscape',
    author: '动漫解析组',
    publishDate: '2026-08-01',
    readTime: '15分钟',
    tags: ['剧情解析', '全集回顾', '故事线'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'ako-character-deep-dive',
    title: '住之江亚香角色深度剖析：温柔姐姐的魅力与内心世界',
    excerpt: '走进住之江亚香的内心世界，从她的性格特质、成长历程到与圭太的情感互动，全方位解析这位温柔姐姐为何能俘获无数观众的心。',
    contentHtml: `<h2>亚香的基本档案</h2><p>住之江亚香（Suminoe Ako）是亲吻姐姐中的双胞胎姐姐，担任学生会会长。她成绩优异、性格温柔，总是以姐姐的身份默默守护着圭太。但在这温柔的外表下，隐藏着一颗对圭太炽热的心。</p><h2>性格分析</h2><p>亚香的性格可以用「外柔内刚」来形容。表面上她是那个总是微笑、善解人意的完美姐姐，但在面对与圭太相关的事情时，她会展现出惊人的决心和行动力。这种反差萌正是亚香角色魅力的核心所在。</p><p>与妹妹理香的直率大胆不同，亚香表达爱意的方式更加含蓄内敛。她倾向于用行动而非言语来表达情感——为圭太准备便当、在他疲惫时给予安慰、在他困惑时提供建议。这种温柔的支持方式让很多观众感同身受。</p><h2>名场面回顾</h2><p>亚香最令人难忘的名场面当属「便当盒里的秘密」。她每天为圭太准备的便当不仅精致美味，更重要的是里面蕴含的心意。便当偶尔出现的爱心形状饭团，是亚香笨拙而真挚的情感表达。</p><p>另一个经典场景是「雨天的等待」。当圭太因社团活动晚归时，亚香撑着伞在校门口静静等待。那个在雨中微笑的身影，成为了亲吻姐姐中最温暖的画面之一。</p>`,
    category: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20long%20dark%20hair%20and%20gentle%20smile%2C%20wearing%20school%20uniform%2C%20soft%20pink%20cherry%20blossom%20background%2C%20warm%20lighting%2C%20tender%20expression%2C%20pastel%20atmosphere%2C%20anime%20style%20illustration%2C%20dreamy%20bokeh%20effect&width=800&height=450&seq=ako-character&orientation=landscape',
    author: '角色研究组',
    publishDate: '2026-07-28',
    readTime: '12分钟',
    tags: ['角色介绍', '住之江亚香', '角色分析'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'riko-character-guide',
    title: '住之江理香角色全解：元气少女的直率魅力',
    excerpt: '住之江理香，亲吻姐姐中的运动系双马尾少女，用她阳光直率的性格为这部作品注入了无限活力。深度解读理香的角色魅力与成长弧光。',
    contentHtml: `<h2>理香的基本档案</h2><p>住之江理香（Suminoe Riko）是亲吻姐姐中的双胞胎妹妹，运动神经发达，性格开朗活泼。与姐姐亚香的温柔内敛形成鲜明对比，理香总是以最直接的方式表达自己对圭太的感情。</p><h2>性格分析</h2><p>理香的核心魅力在于她的「真诚」。她不会掩饰自己的感情，喜欢就是喜欢，想要表达就大胆表达。这种坦率的性格在日系恋爱动漫中并不多见，也正因如此，理香成为了许多观众最喜爱的角色。</p><p>虽然表面看起来大大咧咧，但理香其实也有细腻的一面。她会在意圭太的感受，会因为自己太过主动而后悔，也会在关键时刻展现出令人意外的成熟。这种多层次的角色塑造让理香不仅仅是一个「活泼角色」的标签。</p><h2>经典场景</h2><p>理香最著名的名场面是体育祭上的「全力冲刺」。她在接力赛中为了给圭太所在的班级争取胜利而拼尽全力，冲过终点线后直接扑进圭太怀里的场景，既热血又甜蜜，完美展现了理香的角色特质。</p><p>另一个经典是「厨房大作战」中理香为圭太做料理的场景。虽然最终成品惨不忍睹，但那份笨拙的心意让圭太和观众都深受感动。</p>`,
    category: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20twin%20tails%20and%20energetic%20smile%2C%20wearing%20school%20sports%20uniform%2C%20bright%20sunny%20school%20field%20background%2C%20warm%20golden%20hour%20lighting%2C%20cheerful%20atmosphere%2C%20anime%20style%20illustration%2C%20dynamic%20pose&width=800&height=450&seq=riko-character&orientation=landscape',
    author: '角色研究组',
    publishDate: '2026-07-25',
    readTime: '12分钟',
    tags: ['角色介绍', '住之江理香', '角色分析'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'keita-character-analysis',
    title: '住之江圭太：夹在两位姐姐之间的少年心事',
    excerpt: '作为亲吻姐姐的男主角，住之江圭太在两个姐姐的爱意中摇摆不定。深度解读这位温柔少年的性格特质与成长轨迹。',
    contentHtml: `<h2>圭太的基本档案</h2><p>住之江圭太（Suminoe Keita）是亲吻姐姐的男主角，一个普通的高中生。他与没有血缘关系的双胞胎姐姐亚香和理香住在一起，每天在两位姐姐的爱意包围中度过鸡飞狗跳却又温馨有趣的日常。</p><h2>性格分析</h2><p>圭太的性格核心是「温柔」与「优柔寡断」。他真心关心两位姐姐，不愿意伤害任何一个人，但这种温柔有时反而让他陷入更加复杂的处境。他并非没有自己的感情，只是在面对两位同样深爱自己的姐姐时，做出选择成了一件几乎不可能的事。</p><p>随着故事的发展，圭太也在慢慢成长。他从最初的被动接受两位姐姐的好意，到后来能够主动为她们着想、保护她们。这种成长弧光让圭太不仅仅是一个「后宫男主」的模板角色。</p><h2>角色魅力</h2><p>圭太的魅力在于他的「普通」。他不是完美无缺的男主角，会犹豫、会犯错、会在感情中迷失方向——正是这些「不完美」让他变得真实可爱。很多男性观众在圭太身上看到了自己的影子。</p>`,
    category: 'characters',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20boy%20with%20short%20brown%20hair%20and%20gentle%20expression%2C%20wearing%20Japanese%20high%20school%20uniform%2C%20standing%20between%20two%20girls%20in%20school%20corridor%2C%20warm%20afternoon%20light%2C%20anime%20art%20style%2C%20soft%20focus%20background&width=800&height=450&seq=keita-character&orientation=landscape',
    author: '角色研究组',
    publishDate: '2026-07-20',
    readTime: '10分钟',
    tags: ['角色介绍', '住之江圭太', '男主角'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'voice-actor-taketatsu-ayana',
    title: '竹达彩奈与亲吻姐姐：亚香背后的声音魔法',
    excerpt: '日本知名声优竹达彩奈如何用声音塑造住之江亚香的温柔形象？深度解析竹达彩奈在亲吻姐姐中的配音表现与幕后故事。',
    contentHtml: `<h2>竹达彩奈简介</h2><p>竹达彩奈是日本著名的女性声优，以其甜美温柔的声线而闻名。在亲吻姐姐中，她为住之江亚香配音，完美诠释了这位温柔姐姐的细腻情感。</p><h2>配音特色</h2><p>竹达彩奈在演绎亚香时，巧妙地运用了「轻声细语」与「坚定语气」的对比。在日常对话中，她的声音温柔似水，让人感受到亚香的体贴；而在关键时刻，她的声音又展现出不容置疑的坚定，体现了亚香外柔内刚的性格特质。</p><h2>幕后故事</h2><p>据竹达彩奈在访谈中透露，她为亚香这个角色做了大量准备工作，包括反复阅读原作、揣摩角色的心理变化。她表示亚香是她职业生涯中最具挑战性也最难忘的角色之一。</p>`,
    category: 'voice-actors',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20voice%20actress%20recording%20in%20professional%20studio%20with%20microphone%2C%20warm%20lighting%2C%20anime%20poster%20on%20wall%2C%20professional%20audio%20equipment%2C%20soft%20atmosphere%2C%20behind%20the%20scenes%20style&width=800&height=450&seq=voice-actor-1&orientation=landscape',
    author: '声优专栏',
    publishDate: '2026-07-15',
    readTime: '8分钟',
    tags: ['声优阵容', '竹达彩奈', '住之江亚香'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'voice-actor-sato-satomi',
    title: '佐藤聪美：为理香注入活力的元气声线',
    excerpt: '声优佐藤聪美如何用充满活力的声音演绎住之江理香？全面解析她在亲吻姐姐中的精彩配音表现。',
    contentHtml: `<h2>佐藤聪美简介</h2><p>佐藤聪美是日本实力派女性声优，以其活泼开朗的声音特质著称。在亲吻姐姐中，她为住之江理香配音，赋予了这个运动系少女鲜活的生命力。</p><h2>配音分析</h2><p>佐藤聪美在演绎理香时展现了惊人的声音表现力。理香的每一句台词都充满了能量——无论是撒娇时的甜腻、生气时的炸毛、还是感动时的哽咽，佐藤聪美都能精准把握情感的细微变化。</p><p>特别是在理香大胆表白时的场景，佐藤聪美用略带颤抖却又勇气十足的声音，完美传达了角色内心的紧张与坚定。</p>`,
    category: 'voice-actors',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20voice%20actress%20smiling%20during%20recording%20session%2C%20professional%20studio%20setup%2C%20headphones%20and%20microphone%2C%20warm%20studio%20lighting%2C%20professional%20atmosphere%2C%20creative%20workspace&width=800&height=450&seq=voice-actor-2&orientation=landscape',
    author: '声优专栏',
    publishDate: '2026-07-12',
    readTime: '8分钟',
    tags: ['声优阵容', '佐藤聪美', '住之江理香'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'ova-episode-guide',
    title: '亲吻姐姐OVA全系列观看指南：从OAD到特别篇',
    excerpt: '亲吻姐姐的OVA系列为粉丝带来了不同于TV版的精彩内容。全面梳理OVA全系列的播出顺序、剧情要点与观看建议。',
    contentHtml: `<h2>OVA系列概述</h2><p>亲吻姐姐的OVA（Original Video Animation）系列是这部作品的重要组成部分。与TV版相比，OVA在内容尺度和剧情深度上都有所不同，为粉丝提供了更加丰富的观看体验。</p><h2>OAD系列详解</h2><p>OAD（Original Animation DVD）系列作为漫画单行本的附赠特典，从第3卷开始陆续推出。这些OAD在剧情上更加忠实于原作漫画，同时在画面表现上也更加精致。</p><h2>特别篇分析</h2><p>亲吻姐姐还推出了多部特别篇动画，包括泳装回、温泉回等粉丝喜闻乐见的主题。这些特别篇虽然剧情相对独立，但同样充满了亲吻姐姐式的温馨与搞笑。</p><h2>观看顺序建议</h2><p>建议按照以下顺序观看OVA系列：先看OAD系列（按发行顺序），再看特别篇。这样能够更好地理解角色之间的关系发展和剧情脉络。</p>`,
    category: 'ova',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20DVD%20box%20set%20collection%20display%2C%20colorful%20anime%20cover%20art%2C%20romance%20anime%20style%2C%20warm%20lighting%20on%20shelf%2C%20collector%20display%2C%20pastel%20background%2C%20neat%20arrangement&width=800&height=450&seq=ova-guide&orientation=landscape',
    author: 'OVA研究组',
    publishDate: '2026-07-10',
    readTime: '10分钟',
    tags: ['OVA', 'OAD', '特别篇', '观看指南'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'indirect-kiss-scene',
    title: '名场面解析：间接接吻——史上最心动的一口饮料',
    excerpt: '回顾亲吻姐姐中最著名的名场面「间接接吻」，从分镜设计到声优演绎，全面解析这个让无数观众心动的经典时刻。',
    contentHtml: `<h2>场景背景</h2><p>「间接接吻」是亲吻姐姐最具代表性的名场面之一。在这个场景中，亚香趁圭太不注意的时候，轻轻抿了一口他喝过的饮料。这个看似简单的动作，承载了太多无法言说的情感。</p><h2>分镜分析</h2><p>从动画制作的角度来看，这个场景的分镜设计堪称教科书级别。制作组通过特写镜头捕捉亚香的表情变化——从犹豫到下定决心，从害羞到满足，每一个微表情都被细腻地呈现出来。</p><h2>声优表现</h2><p>竹达彩奈在这个场景中的配音表现堪称完美。那一声轻轻的「嗯…」，包含了千言万语。没有过多的台词，仅凭一个音节就传达了角色内心的全部情感。</p><h2>粉丝反响</h2><p>这个场景播出后在粉丝中引发了巨大反响，被公认为亲吻姐姐最令人心动的名场面。很多粉丝表示，正是这个场景让他们彻底爱上了亚香这个角色。</p>`,
    category: 'iconic-scenes',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20girl%20blushing%20while%20holding%20a%20drink%20bottle%2C%20close-up%20romantic%20moment%2C%20soft%20pink%20blush%2C%20embarrassed%20expression%2C%20anime%20style%2C%20warm%20pastel%20lighting%2C%20intimate%20atmosphere%2C@512&width=800&height=450&seq=indirect-kiss&orientation=landscape',
    author: '名场面分析组',
    publishDate: '2026-07-08',
    readTime: '8分钟',
    tags: ['名场面', '间接接吻', '住之江亚香'],
    isHot: true,
    isNew: true,
  },
  {
    slug: 'rain-scene-analysis',
    title: '名场面解析：雨中相拥——三角关系的情绪爆发点',
    excerpt: '第五话中的雨中相拥场景是亲吻姐姐剧情的关键转折点。从叙事结构到情感表达，深入分析这个推动故事发展的经典场面。',
    contentHtml: `<h2>场景概述</h2><p>第五话的雨中场景是亲吻姐姐剧情的一个重要转折点。亚香在雨中为忘记带伞的圭太送去雨伞，而理香随后也冲入雨中，三人之间的关系在这个雨夜达到了一个情绪的高潮。</p><h2>叙事意义</h2><p>从叙事结构来看，这个场景起到了承上启下的关键作用。在此之前，三人之间的关系虽然暧昧但相对平衡；在此之后，情感的天平开始出现微妙的变化。雨水作为一种常见的叙事符号，在这里象征着情感的宣泄与净化。</p><h2>视觉表现</h2><p>制作组在雨景的处理上相当用心。雨滴的透明度、落地的涟漪、被雨水打湿的头发和衣服——这些细节的处理让整个场景的视觉表现力大大增强。特别是亚香在雨中微笑的特写镜头，成为了无数粉丝心中的经典画面。</p>`,
    category: 'iconic-scenes',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20character%20standing%20in%20rain%20holding%20umbrella%2C%20emotional%20scene%2C%20wet%20school%20uniform%2C%20rain%20drops%20falling%2C%20street%20lamp%20warm%20glow%2C%20anime%20style%2C%20melancholic%20yet%20warm%20atmosphere%2C%20romantic&width=800&height=450&seq=rain-scene&orientation=landscape',
    author: '名场面分析组',
    publishDate: '2026-07-05',
    readTime: '9分钟',
    tags: ['名场面', '雨中相拥', '情感转折'],
    isHot: false,
    isNew: true,
  },
  {
    slug: 'kissxsis-anime-recommendation',
    title: '如果你喜欢亲吻姐姐：10部必看恋爱动漫推荐',
    excerpt: '为亲吻姐姐粉丝精心挑选的10部恋爱动漫推荐，从经典老番到最新热门，总有一部能触动你的心弦。',
    contentHtml: `<h2>推荐前言</h2><p>如果你被亲吻姐姐中的三角恋、温馨日常和甜蜜氛围所打动，那么下面这些恋爱动漫同样值得你一看。我们根据亲吻姐姐的核心魅力元素，精心挑选了十部风格相似或互补的恋爱动漫作品。</p><h2>推荐列表</h2><h3>1. 《我的妹妹不可能这么可爱》</h3><p>同样探讨了非血缘关系的兄妹/姐弟之间微妙的情感变化，剧情轻松有趣，结局令人回味。</p><h3>2. 《路人女主的养成方法》</h3><p>校园背景下的恋爱喜剧，多角关系的设计与亲吻姐姐有异曲同工之妙。</p><h3>3. 《樱花庄的宠物女孩》</h3><p>温馨治愈的日常恋爱番，角色塑造细腻，情感描写真实动人。</p><h3>4. 《龙与虎》</h3><p>经典恋爱动漫的代表作，三角关系的处理堪称教科书级别。</p><h3>5. 《青春猪头少年不会梦到兔女郎学姐》</h3><p>有深度的青春恋爱故事，在甜蜜中融入了对人生和成长的思考。</p>`,
    category: 'plot-analysis',
    coverImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20romance%20anime%20DVD%20covers%20displayed%20on%20wooden%20shelf%2C%20colorful%20anime%20art%2C%20warm%20interior%20lighting%2C%20cozy%20room%20atmosphere%2C%20anime%20collection%2C%20pastel%20color%20scheme&width=800&height=450&seq=anime-recs&orientation=landscape',
    author: '动漫推荐组',
    publishDate: '2026-07-01',
    readTime: '14分钟',
    tags: ['动漫推荐', '恋爱动漫', '相似作品'],
    isHot: false,
    isNew: false,
  },
];